export default __webpack_public_path__ + "static/performance_background-ce6c14454ac8467a713b3066104516e4.jpg";